module.exports = __webpack_public_path__ + "img/2. Project_2.1d694e35.jpg";